function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Widget, WidgetHeader, WidgetBody, WidgetTitle, WidgetDescription, WidgetLoading, Chart, FormatMetric } from "../";
import { getGaChartByType } from "../../resources/functions/"; // import { getGaChartByType, getGaDate, getGaDays, getGaWeeks, getGaMonths } from "../../resources/functions/"

import "./AnalyticsWidget.scss";

class AnalyticsWidget extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      values: {},
      title: undefined,
      description: undefined,
      loading: true,
      chart: undefined
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getReport();
      }
    });

    _defineProperty(this, "getReport", () => {
      let _this$props = this.props,
          report = _this$props.report,
          metric = _this$props.metric,
          dimension = _this$props.dimension,
          scope = _this$props.scope,
          type = _this$props.type,
          compare = _this$props.compare,
          stacked = _this$props.stacked,
          tooltipTitle = _this$props.tooltipTitle,
          tooltipLabel = _this$props.tooltipLabel;
      let chart;

      if (report) {
        chart = getGaChartByType(type, report, metric, dimension);
      } // use chart to set metric and scope


      if (chart) {
        metric = chart.metric;
        scope = scope || chart.scope || undefined;
      } // get id


      let id = [];

      if (metric) {
        id.push(metric.replace("ga:", ""));
      } else {
        id.push("widget");
      }

      if (scope) {
        id.push(scope);
      }

      id = id.join('.'); // set state

      this.setState({
        id: id,
        loading: true
      });

      if (!chart) {
        return false;
      } // set state


      this.setState({
        loading: false,
        chart: _extends({}, chart, {
          type: type,
          compare: compare,
          stacked: stacked,
          tooltipTitle: tooltipTitle,
          tooltipLabel: tooltipLabel
        })
      });
    });

    _defineProperty(this, "getSize", () => {
      const widgetSize = this.props.widgetSize;

      if (!widgetSize) {
        return {};
      }

      const sizes = {
        "xs": 2,
        "s": 4,
        "m": 8,
        "l": 12,
        "xl": 16
      };
      const grid = widgetSize.split(":");
      let cols = grid[0];
      let rows = grid[1];
      cols = sizes[cols] || parseInt(cols);
      rows = sizes[rows] || parseInt(rows);
      return {
        cols: cols,
        rows: rows
      };
    });

    _defineProperty(this, "getMargins", () => {
      const _this$getSize = this.getSize(),
            cols = _this$getSize.cols,
            rows = _this$getSize.rows;

      const chart = this.state.chart;
      let margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
      let offset = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };

      if (chart.type === "pie") {
        return {
          margin: margin,
          offset: offset
        };
      }

      const rowTop = {
        1: 24,
        2: 48,
        3: 60,
        4: 72,
        5: 84
      };
      margin.top = rows && rowTop[rows];

      if (rows > 5) {
        margin.top = rows && rowTop[5];
      }

      if (margin.top) {
        offset.top = margin.top * -1;
      }

      return {
        margin: margin,
        offset: offset
      };
    });

    _defineProperty(this, "renderChart", () => {
      const _this$props2 = this.props,
            theme = _this$props2.theme,
            colors = _this$props2.colors;
      const chart = this.state.chart;

      const _this$getMargins = this.getMargins(),
            margin = _this$getMargins.margin,
            offset = _this$getMargins.offset;

      if (chart) {
        return React.createElement(Chart, _extends({}, chart, {
          margin: margin,
          offset: offset,
          theme: theme,
          colors: colors
        }));
      }
    });
  }

  componentDidMount() {
    this.getReport();
  }

  render() {
    const _this$props3 = this.props,
          widgetSize = _this$props3.widgetSize,
          theme = _this$props3.theme,
          debug = _this$props3.debug,
          url = _this$props3.url,
          title = _this$props3.title,
          description = _this$props3.description,
          trending = _this$props3.trending,
          loadingTitle = _this$props3.loadingTitle;
    const _this$state = this.state,
          id = _this$state.id,
          values = _this$state.values,
          chart = _this$state.chart;
    const loading = this.state.loading || this.props.loading;

    if (debug) {
      return React.createElement("pre", null, JSON.stringify(chart, null, 2));
    }

    if (loading) {
      return React.createElement(Widget, this.props, React.createElement(WidgetLoading, {
        theme: theme,
        title: loadingTitle
      }));
    }

    return React.createElement(Widget, this.props, React.createElement(WidgetHeader, null, React.createElement(WidgetTitle, {
      title: title,
      url: url
    }), React.createElement(WidgetDescription, {
      description: description,
      trending: trending
    })), React.createElement(WidgetBody, null, this.renderChart()));
  }

}

_defineProperty(AnalyticsWidget, "defaultProps", {
  loadingTitle: "Loading widget",
  title: "Widget",
  widgetType: "analytics",
  widgetSize: "1:2",
  report: undefined,
  metric: undefined,
  dimension: undefined,
  scope: undefined,
  type: "line",
  compare: false,
  stacked: false,
  labels: undefined,
  debug: false
});

AnalyticsWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  loadingTitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  trending: PropTypes.string,
  tooltipTitle: PropTypes.string,
  tooltipLabel: PropTypes.string,
  scope: PropTypes.string
} : {};
export default AnalyticsWidget;